<template>
  <div class="spa-guest-treatments">
    <h3 class="spa-guest-treatments__guest-name">
      {{ guestNumber }}. {{ guestFirstName }} {{ guestLastName }}
    </h3>

    <div
      v-for="treatment in filteredTreatments"
      :key="treatment.bookingId"
      class="spa-guest-treatments__treatment"
    >
      <div class="spa-guest-treatments__treatment-header">
        <h4 class="spa-guest-treatments__treatment-name">
          {{ treatment.sitecoreTreatmentDetails.title }}
        </h4>
        <div class="spa-guest-treatments__treatment-details">
          <p class="spa-guest-treatments__treatment-details__time">
            {{ getStartTime(treatment, guestNumber - 1, true) }}
          </p>
          <p class="spa-guest-treatments__treatment-details__category">
            {{ treatment.treatmentCategory.title }}
          </p>
          <p class="spa-guest-treatments__treatment-details__duration">
            {{ treatment.selectedTimeSlot.duration }}
          </p>
          <p
            v-if="treatment.selectedTimeSlot.preferredGender"
            class="spa-guest-treatments__treatment-details__therapist"
          >
            {{ getGenderPreference(treatment) }}
          </p>
          <p
            v-else
            class="spa-guest-treatments__treatment-details__therapist"
          >
            {{ tc('spaSoft.step1.selectedTreatments.noGenderPreferenceLabel') }}
          </p>
        </div>
        <span class="spa-guest-treatments__treatment-price">
          {{ getTreatmentPriceFormatted({
            treatment: treatment.selectedTimeSlot, checkTaxes: true, isReservation: true
          })
          }}
        </span>
        <div class="spa-guest-treatments__cancel">
          <spa-cancel-modal
            :treatment="treatment"
            :guest-number="guestNumber - 1"
            type="treatment"
          >
            <div slot-scope="{ activate }">
              <button
                v-if="!isReservationCancelled"
                type="button"
                class="spa-guest-treatments__cancel-btn"
                @click="activate"
                @keydown.space.prevent="activate"
                @keydown.enter.prevent="activate"
              >
                {{ tc('spaSoft.reservationdetails.cancelTreatmentCta') }}
              </button>
            </div>
          </spa-cancel-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import SpaCancelModal from '../spa-reservation-modals/spa-cancel-modal.vue'

  export default {
    name: 'SpaGuestTreatments',
    components: {
      SpaCancelModal
    },
    props: {
      guestData: {
        type: Object,
        required: true
      },
      guestNumber: {
        type: Number,
        required: true
      }
    },
    computed: {
      ...mapState('spaSoft', ['genderOptions', 'reservationDetailsData']),
      ...mapGetters('currency', ['getDisplayPrice']),
      ...mapGetters('spaSoft', ['isReservationCancelled', 'getTreatmentPriceFormatted', 'getStartTime', 'getGenderPreference']),
      ...mapGetters('i18n', ['tc']),

      guestFirstName() {
        return this.guestData.guest.firstName
      },
      guestLastName() {
        return this.guestData.guest.lastName
      },
      filteredTreatments() {
        return this.guestData.itinerary
      }
    },
  }
</script>
